import toogler from './snippet/toggler';
import select2Init from './snippet/select2';
import team from './modules/team';
import ajaxToKnowledge from './modules/ajax-knowledge';
import ajaxTimeline from './modules/ajax-timeline';
import ajaxProjectPosts from './modules/ajax-project-posts';
import wcag from './snippet/wcag';

class App {
  constructor() {
    toogler();
    select2Init();
    team();
    ajaxTimeline();
    ajaxToKnowledge();
    ajaxProjectPosts();
    wcag();
  }
}

window.addEventListener('DOMContentLoaded', () => new App());
